let preciseIntervals: { [key: number]: { active: boolean; timeoutId: any } } =
  {};
let i = 0;

export function setPreciseInterval(
  callback: (...args: any[]) => any,
  ms: number,
  ...args: any[]
) {
  let previous = Date.now();
  const id = i++;

  preciseIntervals[id] = { active: true, timeoutId: null };

  function exec() {
    if (!preciseIntervals[id]?.active) return;

    const drift = Date.now() - previous;
    previous += ms;

    preciseIntervals[id].timeoutId = setTimeout(() => {
      callback(...args);
      exec();
    }, Math.max(0, ms - drift));
  }

  exec();
  return id;
}

export function clearPreciseInterval(preciseIntervalId: number) {
  const interval = preciseIntervals[preciseIntervalId];
  if (interval) {
    interval.active = false;
    clearTimeout(interval.timeoutId);
    delete preciseIntervals[preciseIntervalId];
    console.log("Cleared precise interval:", preciseIntervalId);
  }
}

export function clearAllIntervals() {
  Object.keys(preciseIntervals).forEach((key) => {
    clearPreciseInterval(Number(key));
  });
}